<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AuthenticatedLayout from './layouts/AuthenticatedLayout.vue'
import AuthLayout from './layouts/AuthLayout.vue'

const route = useRoute()

const layout = computed(() => {
  return route.meta.layout || 'default'
})
</script>

<template>
  <AuthLayout v-if="layout === 'auth'">
    <router-view></router-view>
  </AuthLayout>
  <AuthenticatedLayout v-else>
    <router-view></router-view>
  </AuthenticatedLayout>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  height: 100%;
  margin: 0;
  padding: 0;
  max-width: none;
  text-align: left;
}

/* Hide sidebar during initial render */
body:not(.default-layout) .sidebar {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  transform: translateX(-100%) !important;
}

/* Ensure auth layout takes full viewport */
body.auth-layout {
  overflow-y: auto;
  overflow-x: hidden;
}

body.auth-layout #app {
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.app {
  min-height: 100vh;
}
</style>
